var React = require('react');

function CopyIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.7142 21H10.2858C11.2325 21 12 20.2016 12 19.2167V9.78326C12 8.79839 11.2325 8 10.2858 8H2.7142C1.76747 8 1 8.79839 1 9.78326V19.2185C1.00095 20.2027 1.76814 21 2.7142 21Z","stroke":"#212C04","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M5 7.90331V5.78302C5 4.79829 5.76355 4 6.70543 4H14.2946C14.7469 4 15.1807 4.18785 15.5005 4.52223C15.8203 4.85662 16 5.31013 16 5.78302V15.217C16 16.2017 15.2365 17 14.2946 17H12.2521","stroke":"#212C04","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CopyIcon.defaultProps = {"width":"21","height":"24","viewBox":"0 0 21 24","fill":"none"};

module.exports = CopyIcon;

CopyIcon.default = CopyIcon;
